import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useContextApi } from "../../../context/ContextApi";
import Table from "../../../constants/Table";
import { toPrimaryQuantity, toSecondaryQuantity, toSecondaryUnitPrice } from "@heartinz/finance";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { AddIcon, CheckIcon, XIcon } from "../../../constants/Icons";

const MatchStock = ({
  data,
  addToStockCart,
  onClose,
  mode = "add",
  citem,
  onUpdate,
}) => {
  // console.log("MatchStock Rendered with data:", data, "and citem:", citem);

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [inputValues, setInputValues] = useState({});
  const [landingCosts, setLandingCosts] = useState({});
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [errors, setErrors] = useState({});
  const inputRefs = useRef([]);
  const handleUpdateRef = useRef(null);
  const landingCostRefs = useRef([]);
  const { useEscapeKey } = useContextApi();

  const [selectedUnits, setSelectedUnits] = useState({});

  useEscapeKey(onClose);
  // Focus input on selected index change
  useEffect(() => {
    if (inputRefs.current[selectedIndex]) {
      inputRefs.current[selectedIndex].focus();
    }
  }, [selectedIndex]);

  // useEffect(() => {
  //   if ((mode === "update" || data.cMode === "edit") && citem) {
  //     const index = data.findIndex(
  //       (d) => d._id === citem.stockid || d._id === citem.stocklid,
  //     );
  //     if (index >= 0) {
  //       setSelectedIndex(index);
  //       setInputValues({ [index]: citem.quantity });
  //       setLandingCosts({ [index]: citem.landingcost || 0 });
  //     }
  //   }
  // }, [mode, data.cMode, citem, data]);

  useEffect(() => {
    if ((mode === "update" || data.cMode === "edit") && citem) {
      const index = data.findIndex(
        (d) => d._id === citem.stockid || d._id === citem.stocklid,
      );

      if (index >= 0) {
        const item = data[index];

        const primaryUnit = item?.unitConfig?.primaryUnitCode;

        const secondaryUnit = item?.unitConfig?.secondaryUnitCode;

        let displayQty = citem.quantity;

        let selectedUnit = primaryUnit;

        // IMPORTANT
        // quantity from API is ALWAYS primary qty
        // convert only for display
        if (citem.isSecondaryUnit && secondaryUnit) {
          const converted = toSecondaryQuantity(
            citem.quantity,
            item?.unitConfig || {},
          );

          displayQty =
            typeof converted === "object" ? converted.secondaryQty : converted;

          selectedUnit = secondaryUnit;
        }

        setSelectedIndex(index);

        setInputValues({
          [index]: Number(displayQty)
            .toFixed(3)
            .replace(/\.?0+$/, ""),
        });

        setSelectedUnits({
          [index]: selectedUnit,
        });

        setLandingCosts({
          [index]: citem.landingcost || 0,
        });
      }
    }
  }, [mode, citem, data]);

  // Handle radio selection
  const handleRadioChange = (newIndex) => {
    //  If user selects the same row again → do nothing (keep qty as is)
    if (newIndex === selectedIndex) {
      setSelectedIndex(newIndex); // just update selection
      return;
    }

    //  If user moves to a different row → clear the old row’s qty
    setInputValues((prevValues) => {
      const updatedValues = { ...prevValues };
      updatedValues[selectedIndex] = ""; // clear qty only for old row
      return updatedValues;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[selectedIndex]; // clear error for old row
      return updatedErrors;
    });

    setSelectedIndex(newIndex);
  };

  const handleUnitChange = (index, newUnit) => {
    const item = data[index];

    const primaryUnit = item?.unitConfig?.primaryUnitCode;
    const secondaryUnit = item?.unitConfig?.secondaryUnitCode;

    const oldUnit = selectedUnits[index] || primaryUnit;

    let currentQty = parseFloat(inputValues[index]);

    if (isNaN(currentQty)) currentQty = "";
    let convertedQty = "";

    // let convertedQty = currentQty;

    // Primary -> Secondary
    // if (
    //   oldUnit === primaryUnit &&
    //   newUnit === secondaryUnit &&
    //   currentQty !== ""
    // ) {
    //   const result = toSecondaryQuantity(currentQty, item?.unitConfig || {});

    //   convertedQty = typeof result === "object" ? result.secondaryQty : result;
    // }

    // console.log("Converted quantity for secondary unit:", convertedQty);
    // // Secondary -> Primary
    // if (
    //   oldUnit === secondaryUnit &&
    //   newUnit === primaryUnit &&
    //   currentQty !== ""
    // ) {
    //   const result = toPrimaryQuantity(currentQty, item?.unitConfig || {});

    //   convertedQty = typeof result === "object" ? result.primaryQty : result;
    // }

    setSelectedUnits((prev) => ({
      ...prev,
      [index]: newUnit,
    }));

    setInputValues((prev) => ({
      ...prev,
      [index]:
        convertedQty !== ""
          ? Number(convertedQty)
              .toFixed(3)
              .replace(/\.?0+$/, "")
          : "",
    }));
  };
  const getDisplayPrice = (item, index) => {
    const primaryUnit = item?.unitConfig?.primaryUnitCode;
    const secondaryUnit = item?.unitConfig?.secondaryUnitCode;
    const selectedUnit = selectedUnits[index] || primaryUnit;
    const hasUnitConfig = item?.unitConfig && secondaryUnit;
  
    // No unit config, or primary selected -> show as-is
    if (!hasUnitConfig || selectedUnit === primaryUnit) {
      return {
        mrp: item?.mrp || 0,
        saleprice: item?.saleprice || 0,
      };
    }
  
    // Secondary selected -> convert for display only
    const result = toSecondaryUnitPrice(
      item?.mrp || 0,
      item?.saleprice || 0,
      item?.baseprice || 0,
      item?.taxpercentage || 0,
      1,
      item?.isLock,
      item.unitConfig,
    );
  
    return {
      mrp: result?.secondaryUnitPrice?.mrp || 0,
      saleprice: result?.secondaryUnitPrice?.salePrice || 0,
    };
  };
  
  const getDisplayStockLeft = (item, index) => {
    const primaryUnit = item?.unitConfig?.primaryUnitCode;
    const secondaryUnit = item?.unitConfig?.secondaryUnitCode;
    const selectedUnit = selectedUnits[index] || primaryUnit;
  
    if (!item?.unitConfig || selectedUnit === primaryUnit) {
      return {
        qty: item?.stockLeft || 0,
        unit: item?.stockLeftUnit || primaryUnit || "",
      };
    }
  
    const converted = toSecondaryQuantity(item?.stockLeft || 0, item.unitConfig);
    const qty = typeof converted === "object" ? converted.secondaryQty : converted;
  
    return { qty, unit: secondaryUnit };
  };
  const handleLandingCostChange = (value, index) => {
    // Remove all non-digit and non-decimal characters
    const numericValue = value.replace(/[^\d.]/g, "");

    // Store the raw numeric value internally
    setLandingCosts((prev) => ({
      ...prev,
      [index]: numericValue,
    }));
  };

  // Handle quantity input
  // const handleInputChange = (value, index) => {
  //   const stockLeft = data[index]?.stockLeft || 0;
  //   let parsedValue = String(value ?? "").replace(/\D/g, "");
  //   if (mode === "update" && stockLeft === 0) {
  //     setInputValues((prevValues) => ({
  //       ...prevValues,
  //       [index]: "1",
  //     }));
  //     setErrors((prevErrors) => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[index];
  //       return updatedErrors;
  //     });
  //     return;
  //   }
  //   if (parsedValue === "") {
  //     parsedValue = "";
  //   }
  //   const numericValue = parseInt(parsedValue, 10);
  //   if (!isNaN(numericValue) && numericValue > stockLeft) {
  //     parsedValue = stockLeft.toString();
  //   }
  //   setInputValues((prevValues) => ({
  //     ...prevValues,
  //     [index]: parsedValue,
  //   }));
  //   if (parsedValue !== "" && !isNaN(numericValue)) {
  //     setErrors((prevErrors) => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors[index];
  //       return updatedErrors;
  //     });
  //   }
  // };

  const handleInputChange = (value, index) => {
    const item = data[index];

    const hasUnitConfig =
      item?.unitConfig &&
      item?.unitConfig?.primaryUnitCode &&
      item?.unitConfig?.conversion;

    const primaryUnit = item?.unitConfig?.primaryUnitCode;

    const secondaryUnit = item?.unitConfig?.secondaryUnitCode;

    const selectedUnit = selectedUnits[index] || primaryUnit;

    const isSecondarySelected = hasUnitConfig && selectedUnit === secondaryUnit;

    // regex
    let regex;

    // NO UNIT CONFIG -> INTEGER ONLY
    if (!hasUnitConfig) {
      regex = /^\d*$/;
    } else {
      regex = isSecondarySelected
        ? /^\d*\.?\d{0,1}$/ // secondary
        : /^\d*\.?\d{0,3}$/; // primary
    }

    if (!regex.test(value)) return;

    // allow empty string through directly
    if (value === "" || value === ".") {
      setInputValues((prev) => ({ ...prev, [index]: value }));
      return;
    }

    // parse only for max-stock check
    const parsedValue = hasUnitConfig ? parseFloat(value) : parseInt(value, 10);

    if (isNaN(parsedValue)) {
      setInputValues((prev) => ({ ...prev, [index]: value }));
      return;
    }

    let currentStockValue = Number(item?.stockLeft || 0);

    // convert ONLY when valid unit config exists
    if (hasUnitConfig && isSecondarySelected) {
      try {
        const converted = toSecondaryQuantity(
          currentStockValue,
          item.unitConfig,
        );
        currentStockValue =
          typeof converted === "object" ? converted.secondaryQty : converted;
        currentStockValue = Number(currentStockValue);
      } catch (error) {
        console.error("Unit conversion failed:", error);
      }
    }

    // cap at stock max but KEEP raw string (preserves trailing dot/zeros)
    if (parsedValue > currentStockValue) {
      setInputValues((prev) => ({
        ...prev,
        [index]: String(currentStockValue),
      }));
    } else {
      // store the raw value string so "1." and "1.5" both work while typing
      setInputValues((prev) => ({ ...prev, [index]: value }));
    }

    // clear errors
    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };

  // Add selected stock to cart
  // const handleAdd = () => {
  //   const selectedData = data[selectedIndex];
  //   const quantity = inputValues[selectedIndex];

  //   if (!quantity || isNaN(parseInt(quantity)) || quantity <= 0) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       [selectedIndex]: "Enter a Quantity.",
  //     }));
  //     inputRefs.current[selectedIndex]?.focus();
  //     return;
  //   }

  //   const landingCostValue =
  //     landingCosts[selectedIndex] !== undefined &&
  //     landingCosts[selectedIndex] !== ""
  //       ? parseFloat(landingCosts[selectedIndex]) // ✅ user typed
  //       : citem &&
  //           (citem.stockid === selectedData._id ||
  //             citem.stocklid === selectedData._id)
  //         ? citem.landingcost // ✅ editing mode → take from citem
  //         : (selectedData?.landingcost ?? 0); // ✅ fallback to API landingcost

  //   const stockData = {
  //     stockLinkId: selectedData.stockLinkId,
  //     stocklid: selectedData._id,
  //     stockid: selectedData._id,
  //     productid: selectedData.productid,
  //     title: selectedData.normalizedTitle,
  //     mrp: selectedData.mrp,
  //     saleprice: selectedData.saleprice,
  //     taxpercentage: selectedData.taxpercentage,
  //     baseprice: selectedData.baseprice,
  //     discount: selectedData.discount,
  //     taxamount: selectedData.taxamount,
  //     isLock: selectedData.isLock,
  //     landingcost: CurrencyConverter.toSubunit(landingCostValue || 0, "INR"),
  //     quantity: parseInt(quantity),
  //     status: "RECEIVED",
  //   };
  //   addToStockCart(stockData);
  // };

  const handleAdd = () => {
    const selectedData = data[selectedIndex];
    // console.log(selectedData);
    const enteredQty = parseFloat(inputValues[selectedIndex]);

    const hasUnitConfig =
      selectedData?.unitConfig &&
      selectedData?.unitConfig?.primaryUnitCode &&
      selectedData?.unitConfig?.conversion;

    const selectedUnit =
      selectedUnits[selectedIndex] || selectedData?.unitConfig?.primaryUnitCode;

    const isSecondary =
      hasUnitConfig &&
      selectedUnit === selectedData?.unitConfig?.secondaryUnitCode;

    if (!enteredQty || isNaN(enteredQty) || enteredQty <= 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [selectedIndex]: "Enter a Quantity.",
      }));

      inputRefs.current[selectedIndex]?.focus();
      return;
    }

    const landingCostValue =
      landingCosts[selectedIndex] !== undefined &&
      landingCosts[selectedIndex] !== ""
        ? parseFloat(landingCosts[selectedIndex])
        : citem &&
            (citem.stockid === selectedData._id ||
              citem.stocklid === selectedData._id)
          ? citem.landingcost
          : (selectedData?.landingcost ?? 0);

    // SAFE quantity conversion
    let finalQty = Number(enteredQty);

    if (hasUnitConfig && isSecondary) {
      const converted = toPrimaryQuantity(enteredQty, selectedData.unitConfig);

      finalQty =
        typeof converted === "object" ? converted.primaryQty : converted;
    }

    const stockData = {
      stockLinkId: selectedData.stockLinkId,
      stocklid: selectedData.stockId,
      stockid: selectedData.stockId,
      productid: selectedData.productId,
      title: selectedData.title,
      mrp: selectedData.mrp,
      saleprice: selectedData.saleprice,
      taxpercentage: selectedData.taxpercentage,
      baseprice: selectedData.baseprice,
      discount: selectedData.discount,
      taxamount: selectedData.taxamount,
      isLock: selectedData.isLock,

      landingcost: CurrencyConverter.toSubunit(landingCostValue || 0, "INR"),

      quantity: finalQty,

      enteredquantity: Number(enteredQty),

      isSecondaryUnit: hasUnitConfig ? isSecondary : false,

      status: "RECEIVED",

      ...(hasUnitConfig && {
        unitConfig: selectedData.unitConfig,
      }),
    };

    // console.log("Adding to stock cart:", stockData);

    addToStockCart(stockData);
  };

  // const handleUpdate = () => {
  //   const quantity = inputValues[selectedIndex];

  //   if (!quantity || isNaN(parseInt(quantity)) || quantity <= 0) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       [selectedIndex]: "Enter a Quantity.",
  //     }));
  //     inputRefs.current[selectedIndex]?.focus();
  //     return;
  //   }

  //   // Determine landing cost
  //   let landingCostValue;

  //   if (
  //     landingCosts[selectedIndex] !== undefined &&
  //     landingCosts[selectedIndex] !== ""
  //   ) {
  //     // ✅ User entered landing cost
  //     landingCostValue = parseFloat(landingCosts[selectedIndex]);
  //   } else if (
  //     (data.cMode === "edit" || mode === "update") &&
  //     citem &&
  //     (citem.stockid === data[selectedIndex]?._id ||
  //       citem.stocklid === data[selectedIndex]?._id)
  //   ) {
  //     // ✅ Existing item landing cost (edit mode)
  //     landingCostValue = citem.landingcost;
  //   } else {
  //     // ✅ Default to stock landing cost if available
  //     landingCostValue = data[selectedIndex]?.landingcost ?? 0;
  //   }

  //   const updatedItem = {
  //     ...citem,
  //     quantity: parseInt(quantity),
  //     landingcost: CurrencyConverter.toSubunit(landingCostValue || 0, "INR"),
  //   };
  //   if (onUpdate) onUpdate(updatedItem);
  // };

  const handleUpdate = () => {
    const selectedData = data[selectedIndex];

    const enteredQty = parseFloat(inputValues[selectedIndex]);

    const selectedUnit =
      selectedUnits[selectedIndex] || selectedData?.unitConfig?.primaryUnitCode;

    const isSecondary =
      selectedUnit === selectedData?.unitConfig?.secondaryUnitCode;

    if (!enteredQty || isNaN(enteredQty) || enteredQty <= 0) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [selectedIndex]: "Enter a Quantity.",
      }));

      inputRefs.current[selectedIndex]?.focus();
      return;
    }

    const primaryQty = isSecondary
      ? toPrimaryQuantity(enteredQty, selectedData?.unitConfig || {})
      : enteredQty;

    // console.log(
    //   "Primary Qty:",
    //   primaryQty,
    //   "Entered Qty:",
    //   enteredQty,
    //   "Selected Unit:",
    //   selectedUnit,
    // );

    let landingCostValue;

    if (
      landingCosts[selectedIndex] !== undefined &&
      landingCosts[selectedIndex] !== ""
    ) {
      landingCostValue = parseFloat(landingCosts[selectedIndex]);
    } else if (
      (data.cMode === "edit" || mode === "update") &&
      citem &&
      (citem.stockid === selectedData?._id ||
        citem.stocklid === selectedData?._id)
    ) {
      landingCostValue = citem.landingcost;
    } else {
      landingCostValue = selectedData?.landingcost ?? 0;
    }

    const updatedItem = {
      ...citem,

      quantity: isSecondary
        ? typeof primaryQty === "object"
          ? primaryQty.primaryQty
          : primaryQty
        : Number(enteredQty),

      enteredquantity: Number(enteredQty),

      unitcode: selectedUnit,

      isSecondaryUnit: isSecondary,

      landingcost: CurrencyConverter.toSubunit(landingCostValue || 0, "INR"),
    };

    if (onUpdate) onUpdate(updatedItem);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      const newIndex = (selectedIndex + 1) % data.length;
      handleRadioChange(newIndex);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      const newIndex = (selectedIndex - 1 + data.length) % data.length;
      handleRadioChange(newIndex);
    }
  };

  const handleEnterKey = (e, fieldName, nextRef = null, isLast = false) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const trimmedData = String(inputValues || "").trim();

      if (!trimmedData) {
        setErrors((prev) => ({
          ...prev,
          [fieldName]: "Enter a valid quantity greater than 0.",
        }));
        return;
      }

      setErrors((prev) => ({
        ...prev,
        [fieldName]: "",
      }));

      if (isLast) {
        handleAdd();
      } else if (
        nextRef?.current &&
        typeof nextRef.current.focus === "function"
      ) {
        nextRef.current.focus();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">
                {mode === "add"
                  ? "Stock Availability"
                  : "Edit Stock Availability"}
              </h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-block px-2">
                <h6 className="text-center py-2">
                  <span className="badge rounded-pill bg-label-navy">
                    {data[0]?.code}{" "}
                  </span>
                  &nbsp;- {data[0]?.title}
                </h6>
              </div>

              <Table
                data={data}
                onRowClick={(_, index) => handleRadioChange(index)}
                columns={[
                  {
                    label: "",
                    render: (item, index) => (
                      <input
                        className="input"
                        type="radio"
                        name="productSelection"
                        value={item._id}
                        checked={selectedIndex === index}
                        onChange={() => handleRadioChange(index)}
                      />
                    ),
                  },
                  {
                    label: "MRP",
                    render: (item,index) => {
                      const { mrp } = getDisplayPrice(item, index);
                    return(
                      <span className="badge bg-label-fall rounded-pill">
                        {/* ₹{CurrencyConverter.toCurrency(mrp || 0, "INR")} */}
                        {formatCurrencyFun(mrp)}
                      </span>
                    )},
                  },
                  {
                    label: "Sale Price",
                    render: (item,index) => {
                      const { saleprice } = getDisplayPrice(item, index);
                      return(
                      <span className="badge bg-label-food rounded-pill">
                       {formatCurrencyFun(saleprice)}
                      </span>
                    )},
                  },
                  {
                    label: "Date",
                    render: (item) => (
                      <>
                        <small className="text-truncate d-sm-block badge bg-label-tea rounded-pill mb-1">
                          MFD :{" "}
                          {item?.manufacturedate
                            ? DateConverter.ISOToDisplayFormat(
                                DateConverter.convertToTimeZone(
                                  item?.manufacturedate,
                                  "Asia/kolkata",
                                ),
                              ).date
                            : ""}
                        </small>
                        <small className="text-truncate d-sm-block badge bg-label-red rounded-pill">
                          EXP :{" "}
                          {item?.expiredate
                            ? DateConverter.ISOToDisplayFormat(
                                item.expiredate,
                                "Asia/kolkata",
                              ).date
                            : ""}
                        </small>
                      </>
                    ),
                  },
                  {
                    label: "Stock Left",
                    thClass: "w-10",
                    render: (item,index) => {
                      const { qty, unit } = getDisplayStockLeft(item, index);
                      return(
                      <span className="badge bg-label-space mx-1">
                        {qty} {unit}
                      </span>
                    )},
                  },
                  {
                    label: "Landing Cost",
                    thClass: "w-15",
                    render: (item, index) => (
                      <input
                        type="text"
                        className="form-control text-center"
                        value={
                          landingCosts[index] !== undefined
                            ? landingCosts[index]
                            : mode === "update" &&
                                citem &&
                                (citem.stockid === item._id ||
                                  citem.stocklid === item._id)
                              ? citem.landingcost
                              : (item.landingcost ?? 0)
                        }
                        onChange={(e) =>
                          handleLandingCostChange(e.target.value, index)
                        }
                        ref={(el) => (landingCostRefs.current[index] = el)}
                        onKeyDown={(e) =>
                          handleEnterKey(
                            e,
                            index,
                            inputRefs.current[index],
                            false,
                          )
                        }
                      />
                    ),
                  },
                  // {
                  //   label: "Qty",
                  //   thClass: "w-15",
                  //   render: (item, index) => (
                  //     <>
                  //       <input
                  //         type="text"
                  //         className="form-control text-center"
                  //         ref={(el) => (inputRefs.current[index] = el)}
                  //         value={
                  //           mode === "update" || item.cMode === "edit"
                  //             ? inputValues[index] !== undefined &&
                  //               inputValues[index] !== ""
                  //               ? inputValues[index] // user-typed
                  //               : citem &&
                  //                   (citem.stockid === item._id ||
                  //                     citem.stocklid === item._id)
                  //                 ? citem.quantity // prefill from citem
                  //                 : ""
                  //             : inputValues[index] || "" // add mode
                  //         }
                  //         onChange={(e) => {
                  //           handleInputChange(e.target.value, index);
                  //         }}
                  //         onBlur={(e) => {
                  //           let val = Number(e.target.value);

                  //           if (item.cMode === "edit" && item.stockLeft === 0) {
                  //             val = 1;
                  //           } else {
                  //             let min = 1;
                  //             let max = item.stockLeft > 0 ? item.stockLeft : 1;

                  //             if (!isNaN(val)) {
                  //               if (val < min) val = min;
                  //               if (val > max) val = max;
                  //             } else {
                  //               val = min;
                  //             }
                  //           }

                  //           handleInputChange(val, index);
                  //         }}
                  //         min={
                  //           item.cMode === "edit"
                  //             ? data[index]?.quantity &&
                  //               data[index]?.quantity > 0
                  //               ? data[index].quantity
                  //               : 1
                  //             : 1
                  //         }
                  //         max={item.stockLeft > 0 ? item.stockLeft : 1}
                  //         onKeyDown={(e) =>
                  //           handleEnterKey(
                  //             e,
                  //             index,
                  //             inputRefs.current[index + 1],
                  //             true,
                  //           )
                  //         }
                  //         onFocus={(e) => e.target.select()}
                  //       />
                  //       {errors[index] && (
                  //         <div className="invalid-feedback text-center">
                  //           {errors[index]}
                  //         </div>
                  //       )}
                  //     </>
                  //   ),
                  // },
                  {
                    label: "Qty",
                    thClass: "w-15",
                    render: (item, index) => {
                      const hasUnitConfig =
                        item?.unitConfig && item?.unitConfig?.primaryUnitCode;

                      const primaryUnit = item?.unitConfig?.primaryUnitCode;

                      const secondaryUnit = item?.unitConfig?.secondaryUnitCode;

                      const selectedUnit = selectedUnits[index] || primaryUnit;

                      return (
                        <>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control text-center"
                              ref={(el) => (inputRefs.current[index] = el)}
                              value={inputValues[index] ?? ""}
                              onChange={(e) => {
                                handleInputChange(e.target.value, index);
                              }}
                              onBlur={(e) => {
                                let val = Number(e.target.value);

                                const hasUnitConfig =
                                  item?.unitConfig &&
                                  item?.unitConfig?.primaryUnitCode &&
                                  item?.unitConfig?.conversion;

                                const primaryUnit =
                                  item?.unitConfig?.primaryUnitCode;

                                const secondaryUnit =
                                  item?.unitConfig?.secondaryUnitCode;

                                const selectedUnit =
                                  selectedUnits[index] || primaryUnit;

                                const isSecondarySelected =
                                  hasUnitConfig &&
                                  selectedUnit === secondaryUnit;

                                let maxStock = Number(item.stockLeft || 0);

                                // IMPORTANT:
                                // Convert stockLeft for validation when secondary selected
                                if (hasUnitConfig && isSecondarySelected) {
                                  const converted = toSecondaryQuantity(
                                    maxStock,
                                    item.unitConfig,
                                  );

                                  maxStock =
                                    typeof converted === "object"
                                      ? converted.secondaryQty
                                      : converted;

                                  maxStock = Number(maxStock);
                                }

                                if (item.cMode === "edit" && maxStock === 0) {
                                  val = 1;
                                } else {
                                  let min = 1;
                                  let max = maxStock > 0 ? maxStock : 1;

                                  if (!isNaN(val)) {
                                    if (val < min) val = min;
                                    if (val > max) val = max;
                                  } else {
                                    val = min;
                                  }
                                }

                                handleInputChange(String(val), index);
                              }}
                              onKeyDown={(e) =>
                                handleEnterKey(
                                  e,
                                  index,
                                  inputRefs.current[index + 1],
                                  true,
                                )
                              }
                              onFocus={(e) => e.target.select()}
                            />

                            {/* SHOW DROPDOWN ONLY IF UNIT CONFIG EXISTS */}
                            {hasUnitConfig && (
                              <select
                                className="btn btn-unit shadow-none"
                                style={{ maxWidth: "90px" }}
                                value={selectedUnit}
                                onChange={(e) =>
                                  handleUnitChange(index, e.target.value)
                                }
                              >
                                <option value={primaryUnit}>
                                  {primaryUnit}
                                </option>

                                {secondaryUnit && (
                                  <option value={secondaryUnit}>
                                    {secondaryUnit}
                                  </option>
                                )}
                              </select>
                            )}
                          </div>

                          {errors[index] && (
                            <div className="invalid-feedback d-block text-center">
                              {errors[index]}
                            </div>
                          )}
                        </>
                      );
                    },
                  },
                ]}
              />
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <XIcon iClass={"fs-15"}/> Cancel
              </button>

              {mode === "add" ? (
                <button
                  onClick={handleAdd}
                  ref={handleUpdateRef}
                  type="button"
                  className="btn btn-teal text-right"
                >
                  <AddIcon/> Add
                </button>
              ) : (
                <button
                  onClick={handleUpdate}
                  type="button"
                  className="btn btn-teal text-right"
                >
                  <CheckIcon/> Update
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchStock;
